import moment from "moment-timezone";

const TIMEZONE_VALUES = [
  "UTC",
  "Pacific/Midway",           // UTC-11:00
  "Pacific/Honolulu",         // UTC-10:00
  "America/Anchorage",        // UTC-09:00
  "America/Los_Angeles",      // UTC-08:00
  "America/Denver",           // UTC-07:00
  "America/Chicago",          // UTC-06:00
  "America/New_York",         // UTC-05:00
  "America/Halifax",          // UTC-04:00
  "Europe/London",            // GMT/BST
  "Europe/Paris",             // CET
  "Europe/Berlin",            // CET
  "Europe/Kyiv",
  "Asia/Tokyo",               // JST
  "Australia/Sydney",         // AEDT
];

export const TIMEZONE_OPTIONS = TIMEZONE_VALUES.map((zone) => ({
  value: zone,
  label: `${zone} (UTC${moment.tz(zone).format("Z")})`,
}));
